export default __webpack_public_path__ + "static/media/cub-high-ropes.f37b9e25.jpg";